var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Autocomplete } from "@mui/material";
import { useAllTaxRates } from "../utils/hooks/rates/useTaxRates";
import TextField from "@mui/material/TextField";
var TaxRatePicker = function (_a) {
    var id = _a.id, value = _a.value, onChange = _a.onChange, sx = _a.sx, disabled = _a.disabled;
    var allTaxRates = useAllTaxRates();
    return (_jsx(Autocomplete, { disablePortal: true, id: id || 'tax-rates-picker', options: allTaxRates, fullWidth: true, getOptionLabel: function (option) { return "".concat(option.name || '', "  (").concat(option.rate, "%, ").concat(option.inclusive ? 'inc.' : 'exc.', ")"); }, value: allTaxRates.find(function (r) { return r.id === value; }) || null, renderInput: function (params) { return _jsx(TextField, __assign({}, params, { size: 'small' })); }, onChange: function (e, value) {
            onChange === null || onChange === void 0 ? void 0 : onChange(value === null || value === void 0 ? void 0 : value.id);
        }, sx: sx, disabled: disabled }));
};
export default TaxRatePicker;
